import LinearProgressMui from '@mui/material/LinearProgress';

export const LinearProgress = () => (
  <LinearProgressMui
    color="secondary"
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: (theme) => theme.zIndex.drawer + 3,
      width: '100%',
    }}
  />
);
